'use client';

import { useEffect, useRef, useState } from 'react';

interface IPersonBioExpanderProps {
  readMore: string;
  readLess: string;
  children: React.ReactNode;
}

export function PersonBioExpander({
  readMore,
  readLess,
  children,
}: IPersonBioExpanderProps): React.JSX.Element {
  const [expanded, setExpanded] = useState(false);
  const [canExpand, setCanExpand] = useState(false);
  const paragraphRef = useRef<HTMLParagraphElement>(null);

  useEffect(() => {
    const element = paragraphRef.current;
    if (element && element.scrollHeight > element.clientHeight + 1) {
      setCanExpand(true);
    }
  }, []);

  return (
    <div>
      <p
        ref={paragraphRef}
        className={`max-w-2xl whitespace-pre-line text-base text-foreground/90 leading-relaxed${expanded ? '' : ' line-clamp-6'}`}
      >
        {children}
      </p>
      {canExpand && (
        <button
          type="button"
          onClick={() => {
            setExpanded((value) => !value);
          }}
          className="mt-3 font-semibold text-primary text-sm hover:underline"
        >
          {expanded ? readLess : readMore}
        </button>
      )}
    </div>
  );
}
